import React from "react";
import "./Modal.css";
import { Button, Box, Typography } from '@mui/material';
const Modal = ({show, type = "success", message, children, onClose})=> {
    if(!show) return null;

    const isSuccess = type === "success";
    const isError = type === "error";

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className={`modal-content ${isSuccess ? "modal-success" : ""} ${isError ? "modal-error": ""}`}
            onClick={(e)=> e.stopPropagation()}
            >
                <h3>
                    {isSuccess ? "Sucesso" : isError ? "Atenção" : ""}
                </h3>
                {children ?? <p>{message}</p>}
                <Button onClick={onClose}>Fechar</Button>
            </div>
        </div>
    );
};

export default Modal;